var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ContentLoader from 'react-content-loader';
import { styled } from 'styled-components';
import defaultTheme from '../../../../../landing/components/core/themes/theme';
var Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-p32bxm" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  background: #fff;\n"], ["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  background: #fff;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black95;
});
var StuckStudentsPreloader = function (props) { return (_jsx(Wrapper, __assign({}, props, { children: _jsxs(ContentLoader, __assign({ width: '1024', height: '168', viewBox: '0 0 1024 168' }, { children: [_jsx("rect", { x: '32', y: '8', width: '163', height: '32', rx: '8', fill: defaultTheme.colors.black95 }, void 0), _jsx("rect", { x: '32', y: '56', width: '929', height: '16', rx: '8', fill: defaultTheme.colors.black95 }, void 0), _jsx("rect", { x: '32', y: '88', width: '929', height: '24', rx: '8', fill: defaultTheme.colors.black95 }, void 0), _jsx("rect", { x: '32', y: '128', width: '929', height: '24', rx: '8', fill: defaultTheme.colors.black95 }, void 0)] }), void 0) }), void 0)); };
export { StuckStudentsPreloader };
var templateObject_1;
